import { Chat } from "@launch10/use-langgraph-stream";
import { CHAT_PERSONAS } from "@components/chat/chatPersonas";
import {
  useBrainstormStreamOptions,
  useBrainstormIsNewConversation,
} from "@components/brainstorm/hooks";
import { useAppComposer } from "@hooks/useAppComposer";
import { ChatProvider } from "@components/shared/chat/ChatProvider";
import { BrainstormConversationPage, BrainstormLandingPage } from "@components/brainstorm";
import { useCreditGateProps } from "@hooks/shared";

export default function Brainstorm() {
  const streamOptions = useBrainstormStreamOptions();
  const useComposer = useAppComposer();
  const creditGate = useCreditGateProps();

  return (
    <Chat.Root streamOptions={streamOptions} useComposer={useComposer} personas={CHAT_PERSONAS} {...creditGate}>
      <ChatProvider name="brainstorm" syncKeys={["websiteId", "projectId"]} />
      <BrainstormRouter />
    </Chat.Root>
  );
}

/** Route to landing vs conversation based on stream state. */
function BrainstormRouter() {
  const isNewConversation = useBrainstormIsNewConversation();
  return isNewConversation ? <BrainstormLandingPage /> : <BrainstormConversationPage />;
}
